// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".StoreLocatorMap-module-mapWrapper-1gufi{width:100%;min-height:315px;position:relative}@media(min-width: 768px){.StoreLocatorMap-module-mapWrapper-1gufi{height:100%;display:flex;flex-direction:column;justify-content:center;align-items:center;gap:28px;gap:var(--des-dimension-gap-and-padding-container-large-gap, 28px);flex:1 0;align-self:stretch}}.StoreLocatorMap-module-map-Bl6Yk{width:100%;height:100%;z-index:2}.StoreLocatorMap-module-map-Bl6Yk [class^=ymaps3][class$=\"--controls_vertical\"]{z-index:9 !important}", ""]);
// Exports
exports.locals = {
	"mapWrapper": "StoreLocatorMap-module-mapWrapper-1gufi",
	"map": "StoreLocatorMap-module-map-Bl6Yk"
};
module.exports = exports;
